export const DeliveryType = {
  POST: 'post',
  EMAIL: 'email'
};

export const DELIVERY_TYPES = Object.values(DeliveryType);

export default DeliveryType;
